// The detail route's path segment — `inventoryItem` needs all four parts, so a deep link carries them.
const SEPARATOR = '~';

// encodeURIComponent leaves `~` alone, so the separator is escaped by hand.
const encode = (part) => encodeURIComponent(part ?? '').replace(/~/g, '%7E');
const decode = (part) => {
  try {
    return part ? decodeURIComponent(part) : null;
  } catch {
    return null;
  }
};

export const buildInventoryKey = ({ facilityType, facilityId, materialId, terminalId } = {}) =>
  [facilityType, facilityId, materialId, terminalId].map(encode).join(SEPARATOR);

export const parseInventoryKey = (key) => {
  const [facilityType, facilityId, materialId, terminalId] = String(key ?? '').split(SEPARATOR);
  return {
    facilityType: decode(facilityType),
    facilityId: decode(facilityId),
    materialId: decode(materialId),
    terminalId: decode(terminalId),
  };
};

// A key missing any of the three required parts cannot address a row; the page shows an error.
export const isCompleteInventoryKey = (parsed) =>
  Boolean(parsed?.facilityType && parsed?.facilityId && parsed?.materialId);
